export const captializeFirstLetter = (word) => {
  if(!word) return false;
  return word.charAt(0).toUpperCase() + word.slice(1);
} 